import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../../data/Interfaces';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';
import { statutPaiement, typeFactureList } from './InterfacesDashboards';

function ChiffreAffaireExpert({chiffreAffaire,width,height}){

    ChiffreAffaireExpert.propTypes = {
        chiffreAffaire:PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const [selectedStatutPaiementClient, setSelectedStatutPaiementClient] = useState('all'); // Default selected period
    const [typeFacture, setTypeFacture] = useState('all'); // Default selected period
    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period
    const currentDate = new Date();
    const { i18n } = useTranslation();
    currentDate.setMonth(currentDate.getMonth() - 2);
    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });
    const [chartDataChiffreAffaire,setChartDataChiffreAffaire]= useState(
        {
            series: [],
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    //top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
            },
            options:{
                labels: [],

            }
        });
    const calculateSumByPeriode = (data,typeFacture) => {
        const sumByPeriode = {};

        data.forEach((item) => {
            const periode = item.periode;
            const totalHtExpert = (typeFacture === 'PC') ? parseFloat(item.totalHtExpertPrestaCompl) : parseFloat(item.totalHtExpert);

            if (!sumByPeriode[periode]) {
                sumByPeriode[periode] = {
                    count: 1,
                    periode: periode,
                    totalesHtExpert: totalHtExpert,
                };
            } else {
                sumByPeriode[periode].count += 1;
                sumByPeriode[periode].totalesHtExpert += totalHtExpert;
            }
        });

        return sumByPeriode;
    };
    useEffect(()=>{
        if(Array.isArray(chiffreAffaire)){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            var filteredData;
            filteredData=chiffreAffaire;
            if (selectedStatutPaiementClient != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaimentClient == selectedStatutPaiementClient
                );
            }
            if (typeFacture!='all') {
                if(typeFacture=='normal')
                    filteredData = filteredData.filter(
                        (item) => item.typeFacture=='facture' || item.typeFacture=='regularisation'
                    );
                else
                    filteredData = filteredData.filter(
                        (item) => item.typeFacture=='factureX' || item.typeFacture=='regularisationX'
                    );
            }
            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            const counts=calculateSumByPeriode(filteredData,typeFacture);

            setChartDataChiffreAffaire((prevState) => {
                return {
                    ...prevState,

                    series: [
                        {
                            data:Object.values(counts).map(item => typeof item.totalesHtExpert === 'string'
                                ? parseFloat(item.totalesHtExpert).toFixed(2)
                                : item.totalesHtExpert.toFixed(2)),
                        }
                    ],

                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis, // Make sure to copy the previous xaxis properties
                            type:'datetime',
                            categories: Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[chiffreAffaire,customDateRange,selectedPeriod,selectedStatutPaiementClient,typeFacture]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Analyse chiffre d\'affaires')}</h1>
                <div className='filtre1'>
                    <div style={{width:'30%'}}>
                        <SelectComponent
                            label={i18n.t('Statut paiement/Expert')}
                            val={selectedStatutPaiementClient}
                            name='Statut paiement/Expert'
                            setVal={(e) => {
                                setSelectedStatutPaiementClient(e.target.value);
                            }}
                            listVal={statutPaiement}
                        />
                    </div>
                    <div style={{width:'30%'}}>
                        <SelectComponent
                            label={i18n.t('Type Facture')}
                            val={typeFacture}
                            name='Type Facture'
                            setVal={(e) => {
                                setTypeFacture(e.target.value);
                            }}
                            listVal={typeFactureList}
                        />
                    </div>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}
                        />
                    </div>

                </div>

                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataChiffreAffaire.options}
                        series={chartDataChiffreAffaire.series}
                        type="line"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );

}
export default ChiffreAffaireExpert;